import React from 'react';
import { Card } from 'react-bootstrap';
import { ResponsivePie } from '@nivo/pie';
import { toBrCurrency } from '../../utils/utils';

const SalesGoalV2 = ({ metaVenda }) => {
	const colors = ['#007bff', '#39cd33', '#00000008'];

	const { sales: vendido, goal: meta } = metaVenda ? metaVenda : {};

	const buildData = () => {
		const acimaVal = vendido - meta ? vendido - meta : 0;

		const vendidoVal = acimaVal > 0 ? vendido - acimaVal : vendido;

		const metaVal = meta > vendido ? meta - vendido : 0;

		const acimaValFixed = toBrCurrency(acimaVal > 0 ? acimaVal : 0);

		const buildedData = [
			{
				id: 'Sobremeta',
				label: `Acima da Meta: R$ ${acimaValFixed}`,
				value: acimaVal ? acimaVal : 1,
			},
			{
				id: 'Vendido',
				label: `Vendido: R$ ${toBrCurrency(vendido ? vendido : 0)}`,
				value: vendidoVal ? vendidoVal : 1,
			},
			{
				id: 'Meta',
				label: `Meta: R$ ${toBrCurrency(meta ? meta : 0)}`,
				value: metaVal ? metaVal : 1,
			},
		];

		return buildedData;
	};

	const renderTooltip = (d) => <div>{d.label}</div>;

	const metaPerc = (vendido && meta ? (vendido / meta) * 100 : 0).toFixed(2);

	const artigoCotaDescr = metaVenda ? metaVenda.articleDescription : '';

	return (
		<div className="div-indicador">
			{/* @ts-ignore */}
			<Card className="card-indicador">
				{/* @ts-ignore */}
				<Card.Header style={{ fontWeight: 'bold' }}>
					{artigoCotaDescr
						? `${artigoCotaDescr} | Meta: ${metaPerc}%`
						: 'Meta x Vendas'}
					{/* <div data-tip={tip} className="fas fa-info-circle ml-1" /> */}
				</Card.Header>
				{/* @ts-ignore */}
				<Card.Body>
					<div className="pie">
						{/* @ts-ignore */}
						<ResponsivePie
							data={buildData()}
							sliceLabel={(e) => {
								return 'R$ ' + toBrCurrency(e.value);
							}}
							margin={{ top: 0, right: 100, bottom: 30, left: 100 }}
							innerRadius={0.7}
							// padAngle={2}
							slicesLabelsSkipAngle={45}
							colors={colors}
							borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
							enableRadialLabels={false}
							animate={true}
							motionStiffness={90}
							motionDamping={15}
							startAngle={-90}
							endAngle={90}
							tooltip={(d) => renderTooltip(d)}
							legends={[
								{
									anchor: 'bottom',
									direction: 'column',
									translateY: 30,
									translateX: 40,
									itemWidth: 200,
									itemHeight: 16,
									itemTextColor: '#999',
									symbolSize: 12,
									symbolShape: 'circle',
									effects: [
										{
											on: 'hover',
											style: {
												itemTextColor: '#000',
											},
										},
									],
								},
							]}
						/>
					</div>
				</Card.Body>
			</Card>
		</div>
	);
};

export default SalesGoalV2;
